import { apiClient } from "@/config/api";
import {
  Article,
  CreateArticleDto,
  UpdateArticleDto,
  GetPaginationArticlesDto,
  ArticleListResponse,
} from "@/types/article";
import { ApiResponse } from "@/types/status";

const ARTICLE_ENDPOINTS = {
  CREATE: "/articles",
  GET_ALL: "/articles",
  GET_BY_ID: (id: string) => `/articles/${id}`,
  GET_BY_SLUG: (slug: string) => `/articles/slug/${slug}`,
  UPDATE: (id: string) => `/articles/${id}`,
  DELETE: (id: string) => `/articles/${id}`,
  CHANGE_STATUS: (id: string) => `/articles/${id}/status`,
  TOGGLE_DISPLAY: (id: string) => `/articles/${id}/toggle-display`,
  CREATE_BULK: "/articles/bulk",
  BULK_ASSIGN_SERIES: "/articles/series/bulk-assign",
} as const;

export const articleService = {
  // Tạo bài viết mới
  create: async (
    data: FormData | CreateArticleDto
  ): Promise<ApiResponse<Article>> => {
    return await apiClient.post(ARTICLE_ENDPOINTS.CREATE, data);
  },
  bulkAssignSeries: async (data: { seriesKey: string; items: { id: string; partNumber: string | number }[] }): Promise<ApiResponse<any>> => {
    return await apiClient.post(ARTICLE_ENDPOINTS.BULK_ASSIGN_SERIES, data);
  },
  createBulk: async (data: {
    movie_ids: string[];
  }): Promise<ApiResponse<any>> => {
    return await apiClient.post(ARTICLE_ENDPOINTS.CREATE_BULK, data);
  },
  // Lấy danh sách bài viết với phân trang
  getPaginationArticles: async (
    params: GetPaginationArticlesDto
  ): Promise<ApiResponse<ArticleListResponse>> => {
    // Truyền thẳng params (không bọc trong { params }) để tránh ?params=[object Object]
    return await apiClient.get(ARTICLE_ENDPOINTS.GET_ALL, params as any);
  },

  // Lấy tất cả bài viết
  getAllArticles: async (): Promise<ApiResponse<Article[]>> => {
    return await apiClient.get(ARTICLE_ENDPOINTS.GET_ALL);
  },

  // Lấy bài viết theo ID
  getArticleById: async (id: string): Promise<ApiResponse<Article>> => {
    return await apiClient.get(ARTICLE_ENDPOINTS.GET_BY_ID(id));
  },

  // Lấy bài viết theo slug
  getArticleBySlug: async (slug: string): Promise<ApiResponse<Article>> => {
    return await apiClient.get(ARTICLE_ENDPOINTS.GET_BY_SLUG(slug));
  },

  // Cập nhật bài viết
  updateArticle: async (
    id: string,
    data: FormData | UpdateArticleDto
  ): Promise<ApiResponse<Article>> => {
    return await apiClient.put(ARTICLE_ENDPOINTS.UPDATE(id), data);
  },

  // Thay đổi trạng thái bài viết
  changeStatus: async (
    id: string,
    status: string
  ): Promise<ApiResponse<Article>> => {
    return await apiClient.put(ARTICLE_ENDPOINTS.CHANGE_STATUS(id), { status });
  },

  // Toggle hiển thị bài viết
  toggleDisplay: async (id: string): Promise<ApiResponse<Article>> => {
    return await apiClient.put(ARTICLE_ENDPOINTS.TOGGLE_DISPLAY(id));
  },

  // Xóa bài viết
  deleteArticle: async (id: string): Promise<ApiResponse<void>> => {
    return await apiClient.delete(ARTICLE_ENDPOINTS.DELETE(id));
  },
};
